import { rolesPageActionTypes } from '@actions/actionTypes/rolesPage';

export const setIsOpenRoleDeleteModal = (isOpen: boolean) => {
  return {
    type: rolesPageActionTypes.SET_IS_OPEN_ROLE_DELETE_MODAL,
    payload: isOpen,
  };
};
